module.exports = __webpack_public_path__ + "static/add-recipes-dfdddc16972bbb50726fef442df7ea39.mp4";